// extracted by mini-css-extract-plugin
module.exports = {"imgTextC":"ImgTextC_imgTextC__5dScU"};